import { Component } from '@angular/core';
import { MoveModalSandbox } from '@app/move/sandboxes/move-modal.sandbox';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';

@Component({
    selector: 'app-reading-meters',
    template: `
        <app-dashboard-card
            [first]="true"
            [title]="'DASHBOARD.UTILITY_TRANSFER.ENERGY.TITLE' | translate"
            [text]="this.moveSandbox.formattedMovingAddress$ | async"
            [hasBorderBottom]="true"
            imageName="laptop-meters.png"
            [last]="true"
        >
            <ng-container up-to-and-including-phone-landscape>
                <div class="u-flex-column u-flex-align-items-stretch">
                    <ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{ class: 'u-margin-bottom-half' }"></ng-container>
                </div>
            </ng-container>
            <ng-container tablet-portrait-up>
                <div class="u-flex-row u-flex-align-items-center">
                    <ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{ class: 'u-margin-right' }"></ng-container>
                </div>
            </ng-container>
        </app-dashboard-card>

        <ng-template #actions let-class="class">
            <app-button
                theme="secondary-outline"
                [class]="class"
                (click)="openMeterInfo()"
            >
                {{ 'DASHBOARD.UTILITY_TRANSFER.ENERGY.CTA' | translate }}</app-button
            >
        </ng-template>
    `,
})
export class ReadingMetersComponent {
    constructor(
        public readonly moveSandbox: MoveSandbox,
        private readonly moveModalSandbox: MoveModalSandbox,
    ) {}

    public openMeterInfo(): void {
        this.moveModalSandbox.showEditableMeterReadingsEnergy();
    }
}
